import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LandingComponent } from "./landing/landing.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard, DomainRouteGuard } from "./services/auth.service";
import { UnauthorizedPageComponent } from "./unauthorized/unauthorized.component";

const routes: Routes = [
  {
    path: "home",
    component: LandingComponent,
    canActivate: [DomainRouteGuard],
  },
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "login", canActivate: [AuthGuard], component: LoginComponent },
  {
    path: "unauthorized/:unauthorizedType",
    component: UnauthorizedPageComponent,
  },
  {
    path: "studio",
    loadChildren: () =>
      import("./main-container/main-container.module").then(
        (m) => m.MainContainerModule
      ),
    canActivate: [DomainRouteGuard],
  },
  {
    path: "ai-imagery",
    loadChildren: () =>
      import("./ai-imagery/ai-imagery.module").then((m) => m.AiImageryModule),
    canActivate: [DomainRouteGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: "enabled",
      scrollOffset: [0, 64],
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
